import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  Flex,
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { Formik, Form } from 'formik';
import InputField from 'components/formComponents/inputField';
import SelectField from 'components/formComponents/selectField';
import { ChargesFormValidationSchema } from 'formValidations/savingPlanChargesFormValidation';
import VariantChargesApi from 'api/variantcharges';

const EditModal = (props) => {
  const toastIdRef = React.useRef();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();

  const initialRef = React.useRef(null);
  const finalRef = React.useRef(null);

  const initialValues = {
    variantId: props.initialData?.saving_plan_variant_id || '',
    name: props.initialData?.name || '',
    base_amount: props.initialData?.base_amount || '',
    gst: props.initialData?.gst || '',
    total_amount: props.initialData?.total_amount || '',
    type: props.initialData?.type || '',
  };

  function calculateTotalWithGST(baseAmount, gstPercentage) {
    const base = parseFloat(baseAmount) || 0;
    const gst = parseFloat(gstPercentage) || 0;
    const gstAmount = (base * gst) / 100;
    const totalAmount = base + gstAmount;
    return totalAmount;
  }
  const id = props.initialData?.id;

  const handleSubmit = async (values, actions) => {
    try {
      const api = await VariantChargesApi.Update({ id, ...values });
      console.log('Api response', api);
      if (api.data.status_code === 200) {
        toastIdRef.current = toast({
          title: api?.data?.message || 'Successfully Updated',
          status: 'success',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
        onClose();
        props.func();
      } else {
        toastIdRef.current = toast({
          title: api?.data?.message,
          status: 'error',
          duration: 1000,
          isClosable: true,
          position: 'top',
        });
      }
    } catch (err) {
      console.log(err);
      toastIdRef.current = toast({
        title: 'Error updating variant charge',
        status: 'error',
        duration: 1000,
        isClosable: true,
        position: 'top',
      });
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <>
      <Button
        variant='auth'
        fontSize='sm'
        fontWeight='500'
        borderRadius='10px'
        px='15px'
        py='5px'
        disabled={props.disabled}
        onClick={onOpen}
      >
        {props.Icon}
      </Button>
      <Modal
        initialFocusRef={initialRef}
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{props.head}</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <Formik
              initialValues={initialValues}
              validationSchema={ChargesFormValidationSchema}
              onSubmit={handleSubmit}
            >
              {({ isSubmitting, values, setFieldValue }) => (
                <Form noValidate>
                  <InputField
                    label='Name'
                    name='name'
                    type='text'
                    variant='auth'
                    placeholder='Enter Name'
                    required
                  />
                  <InputField
                    label='Base Amount'
                    name='base_amount'
                    type='number'
                    placeholder='Base amount'
                    required
                    onChange={(e) => {
                      setFieldValue('base_amount', e.target.value);
                      setFieldValue(
                        'total_amount',
                        calculateTotalWithGST(e.target.value, values.gst)
                      );
                    }}
                  />
                  <InputField
                    label='GST (in %)'
                    name='gst'
                    type='number'
                    placeholder='GST (in percentage)'
                    required
                    onChange={(e) => {
                      setFieldValue('gst', e.target.value);
                      setFieldValue(
                        'total_amount',
                        calculateTotalWithGST(
                          values.base_amount,
                          e.target.value
                        )
                      );
                    }}
                  />
                  <InputField
                    label='Total Amount'
                    name='total_amount'
                    type='number'
                    placeholder='Total Amount'
                    value={values.total_amount}
                    required
                    isReadOnly
                  />
                  <SelectField
                    label='type'
                    name='type'
                    options={[
                      { value: 'ACCOUNT_OPEN', label: 'Account Open' },
                      // { value: 'ACCOUNT_CLOSED', label: 'Account Closed' },
                      // {
                      //   value: 'PREMATURE_WITHDRAWAL',
                      //   label: 'Premature Withdrawal',
                      // },
                    ]}
                    placeholder='Select Type'
                    required
                  />

                  <ModalFooter>
                    <Button
                      colorScheme='blue'
                      mr={3}
                      type='submit'
                      isLoading={isSubmitting}
                    >
                      Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                  </ModalFooter>
                </Form>
              )}
            </Formik>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};

export default EditModal;
